import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import enRoleTranslation from '../languages/locales/en/Role/translation.json';
import frRoleTranslation from '../languages/locales/fr/Role/translation.json';
import deRoleTranslation from '../languages/locales/de/Role/translation.json';

import enClientTranslation from '../languages/locales/en/Client/translation.json';
import frClientTranslation from '../languages/locales/fr/Client/translation.json';
import deClientTranslation from '../languages/locales/de/Client/translation.json';

import enInvoiceListTranslation from '../languages/locales/en/Invoice/InvoiceList.json';
import frInvoiceListTranslation from '../languages/locales/fr/Invoice/InvoiceList.json';
import deInvoiceListTranslation from '../languages/locales/de/Invoice/InvoiceList.json';

import enTeamTranslation from '../languages/locales/en/Team/translation.json';
import frTeamTranslation from '../languages/locales/fr/Team/translation.json';
import deTeamTranslation from '../languages/locales/de/Team/translation.json';

import enUserTranslation from '../languages/locales/en/User/translation.json';
import frUserTranslation from '../languages/locales/fr/User/translation.json';
import deUserTranslation from '../languages/locales/de/User/translation.json';

import enAssetCategoryTranslation from '../languages/locales/en/AssetCategory/transaltion.json';
import frAssetCategoryTranslation from '../languages/locales/fr/AssetCategory/AssetCategory.json';
import deAssetCategoryTranslation from '../languages/locales/de/AssetCategory/translation.json';

import enJobListTranslation from '../languages/locales/en/jobs/jobList.json';
import frJobListTranslation from '../languages/locales/fr/jobs/jobList.json';
import deJobListTranslation from '../languages/locales/de/Jobs/jobList.json';

import enAgreementListTranslation from '../languages/locales/en/Agreement/AgreementList.json';
import frAgreementListTranslation from '../languages/locales/fr/Agreement/AgreementList.json';
import deAgreementListTranslation from '../languages/locales/de/Agreement/AgreementList.json';

import enAssetListTranslation from '../languages/locales/en/Asset/AssetList.json';
import frAssetListTranslation from '../languages/locales/fr/Asset/AssetList.json';
import deAssetListTranslation from '../languages/locales/de/Asset/AssetList.json';

import enCustomerListTranslation from '../languages/locales/en/Customer/CustomerList.json';
import frCustomerListTranslation from '../languages/locales/fr/Customer/CustomerList.json';
import deCustomerListTranslation from '../languages/locales/de/Customer/CustomerList.json';

import enLeadListTranslation from '../languages/locales/en/Lead/LeadList.json';
import frLeadListTranslation from '../languages/locales/fr/Lead/LeadList.json';
import deLeadListTranslation from '../languages/locales/de/Lead/LeadList.json';

import enOpportunityListTranslation from '../languages/locales/en/Opportunity/OpportunityList.json';
import frOpportunityListTranslation from '../languages/locales/fr/Opportunity/OpportunityList.json';
import deOpportunityListTranslation from '../languages/locales/de/Opportunity/OpportunityList.json';

import enContactListTranslation from '../languages/locales/en/Contact/ContactList.json';
import frContactListTranslation from '../languages/locales/fr/Contact/ContactList.json';
import deContactListTranslation from '../languages/locales/de/Contact/ContactList.json';

import enPartListTranslation from '../languages/locales/en/Part/partList.json';
import frPartListTranslation from '../languages/locales/fr/Part/partList.json';
import dePartListTranslation from '../languages/locales/de/Part/partList.json';

import enPurchasingListTranslation from '../languages/locales/en/Purchasing/PurchaseList.json';
import frPurchasingListTranslation from '../languages/locales/fr/Purchasing/purchaseList.json';
import dePurchasingListTranslation from '../languages/locales/de/Purchasing/purchaseList.json';

import enQuotationListTranslation from '../languages/locales/en/Quotation/QuotationList.json';
import frQuotationListTranslation from '../languages/locales/fr/Quotation/QuotationList.json';
import deQuotationListTranslation from '../languages/locales/de/Quotation/QuotationList.json';

import enSaleOrderListTranslation from '../languages/locales/en/SaleOrder/SaleOrderList.json';
import frSaleOrderListTranslation from '../languages/locales/fr/SaleOrder/SaleOrderList.json';
import deSaleOrderListTranslation from '../languages/locales/de/SaleOrder/SaleOrderList.json';

import enSuppliersListTranslation from '../languages/locales/en/Suppliers/SuppliersList.json';
import frSuppliersListTranslation from '../languages/locales/fr/Suppliers/SuppliersList.json';
import deSuppliersListTranslation from '../languages/locales/de/Suppliers/SuppliersList.json';

// Define translations
const resources = {
  en: {
    translation: {
      ...enRoleTranslation,
      ...enClientTranslation,
      ...enTeamTranslation,
      ...enUserTranslation,
      ...enAssetCategoryTranslation,
      ...enJobListTranslation,
      ...enInvoiceListTranslation,
      ...enAgreementListTranslation,
      ...enAssetListTranslation,
      ...enCustomerListTranslation,
      ...enLeadListTranslation,
      ...enOpportunityListTranslation,
      ...enContactListTranslation,
      ...enPartListTranslation,
      ...enPurchasingListTranslation,
      ...enQuotationListTranslation,
      ...enSaleOrderListTranslation,
      ...enSuppliersListTranslation,
    },
  },
  fr: {
    translation: {
      ...frRoleTranslation,
      ...frClientTranslation,
      ...frTeamTranslation,
      ...frUserTranslation,
      ...frAssetCategoryTranslation,
      ...frJobListTranslation,
      ...frInvoiceListTranslation,
      ...frAgreementListTranslation,
      ...frAssetListTranslation,
      ...frCustomerListTranslation,
      ...frLeadListTranslation,
      ...frOpportunityListTranslation,
      ...frContactListTranslation,
      ...frPartListTranslation,
      ...frPurchasingListTranslation,
      ...frQuotationListTranslation,
      ...frSaleOrderListTranslation,
      ...frSuppliersListTranslation,
    },
  },
  de: {
    translation: {
      ...deRoleTranslation,
      ...deClientTranslation,
      ...deTeamTranslation,
      ...deUserTranslation,
      ...deAssetCategoryTranslation,
      ...deJobListTranslation,
      ...deInvoiceListTranslation,
      ...deAgreementListTranslation,
      ...deAssetListTranslation,
      ...deCustomerListTranslation,
      ...deLeadListTranslation,
      ...deOpportunityListTranslation,
      ...deContactListTranslation,
      ...dePartListTranslation,
      ...dePurchasingListTranslation,
      ...deQuotationListTranslation,
      ...deSaleOrderListTranslation,
      ...deSuppliersListTranslation,
    },
  },
};

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // Set the default language here
    fallbackLng: 'en', // Fallback language in case translation is missing
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;